module.exports = __webpack_public_path__ + "static/media/accounting.c59daae7.svg";